<div style="width: 100%;">
    <ng-container *ngIf="!noText">
        <h4> {{ 'REGISTER_CARD_TO_TOTALUM' | translate }}</h4>
    </ng-container>

    <div #cardElement id="cardElement"></div>
    <br>
    <br>
    <div class="ds-accounts-body-box-form-button">
        <div></div>
        <button [disabled]="loading" class="ds-button-primary" (click)="handleSubmit()">
            <ng-container *ngIf="!loading">
                {{ 'REGISTER_CARD' | translate }}
              </ng-container>

              <ng-container *ngIf="loading">
                <ion-spinner name="crescent"></ion-spinner>
                {{ 'REGISTERING_CARD' | translate }}
              </ng-container>
            
        </button>

    </div>
</div>
